import { cloneDeep } from 'lodash';
const SET_ENROLL_PAYMENT_SUCCESS = 'SET_ENROLL_PAYMENT_SUCCESS';
const SET_ENROLL_PAYMENT_SUCCESS_FALSE = 'SET_ENROLL_PAYMENT_SUCCESS_FALSE';

const initialStateEnrollPayment = false;

export default function reducer(state = cloneDeep(initialStateEnrollPayment), action) {
	switch (action.type) {
		case SET_ENROLL_PAYMENT_SUCCESS:
			return true;
		case SET_ENROLL_PAYMENT_SUCCESS_FALSE:
			return false;
		default:
			return state;
	}
}

export function fireEnrollPaymentSuccess(){
	return { type: SET_ENROLL_PAYMENT_SUCCESS }
}

export function clearEnrollPaymentSuccess(){
	return { type: SET_ENROLL_PAYMENT_SUCCESS_FALSE }
}


// WEBPACK FOOTER //
// ./src/modules/enroll_payment_success.js